import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalComponent } from '../../../lib/services/modal.service';
import { take } from 'rxjs/operators';
import { UnitService } from '../../../lib/services';
import { Router } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { selectPaymentState } from '../../../core/selectors/paymentState';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../reducers';

enum stateEnum {
  initial = 0,
  plans,
  billing,
}

@Component({
  selector: 'mj-unpaid',
  templateUrl: './unpaid.component.html',
  styleUrls: ['./unpaid.component.scss'],
})
export class UnpaidComponent extends ModalComponent
  implements OnInit, OnDestroy {
  unit;
  currentState = stateEnum.initial;

  selectedPlan;
  paymentStatus$;

  constructor(
    private companyService: UnitService,
    private router: Router,
    location: PlatformLocation,
    private store: Store<fromRoot.State>
  ) {
    super();

    location.onPopState(() => {
      this.router.navigate(['/']);
      this.resolve.next(null);
    });
  }

  ngOnInit() {
    this.paymentStatus$ = this.store
      .select(selectPaymentState)
      .subscribe(payment => {
        const unitID = Number(localStorage.getItem('unit_id'));

        this.companyService
          .getUnit(unitID)
          .pipe(take(1))
          .subscribe(unit => {
            this.unit = unit;

            if (
              payment.status &&
              payment.unit_id === this.unit.id &&
              (payment.status === 'active' ||
                payment.status === 'always_active')
            ) {
              this.router.navigate(['dashboard', 'overview']);
              this.resolve.next(null);
            }
          });
      });
  }

  ngOnDestroy(): void {
    this.paymentStatus$.unsubscribe();
  }

  onClickBack() {
    this.router.navigate(['/']);
    this.resolve.next(null);
  }

  onGoToPlans() {
    this.currentState = stateEnum.plans;
  }

  onPlanSelected(plan) {
    this.selectedPlan = plan;
    this.currentState = stateEnum.billing;
  }

  closeModal() {
    this.resolve.next(null);
    this.router.navigate(['dashboard', 'overview']);
  }
}
